import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import Modal from "../../Modal/Modal";
import { ITableColumn } from "../../../Typings/TableColumn";

export default function TableColumnSelection({
  columns,
  viewableColumns,
  onCheckboxChange,
  isOpen,
  handleModalClose,
}: {
  columns: ITableColumn[];
  viewableColumns: ITableColumn[];
  onCheckboxChange: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
  isOpen: boolean;
  handleModalClose: () => void;
}) {
  return (
    <Modal
      title="Edit Table Columns"
      content={
        <>
          <FormGroup>
            {columns
              .filter((c) => c.label !== "Actions")
              .map((c, index) => {
                const isChecked =
                  (viewableColumns ?? columns).filter((v) => v.label.toLowerCase() === c.label.toLowerCase())
                    .length > 0;
                const isDisabled = viewableColumns && viewableColumns?.length <= 1 && isChecked;
                return (
                  <FormControlLabel
                    key={"edit-column-label-" + index}
                    control={
                      <Checkbox
                        key={"edit-column-checkbox-" + index}
                        defaultChecked={isChecked}
                        onChange={onCheckboxChange}
                        value={c.label}
                        disabled={isDisabled}
                        aria-label={`column checkbox ${c.label}`}
                      />
                    }
                    label={c.label}
                  />
                );
              })}
          </FormGroup>
        </>
      }
      footerContent={<></>}
      dataTestId="edit-table-columns"
      handleCloseModal={handleModalClose}
      isOpen={isOpen}
    />
  );
}
